import { Component } from '@angular/core';
import { LoaderService } from '../../services/loader.service';
import { animate, AnimationEvent, state, style, transition, trigger } from '@angular/animations';

@Component({
    selector: 'ez-loader',
    template: require('./loader.component.html'),
    styles: [require('./loader.component.less')],
    animations: [
        trigger('state', [
            state('inactive', style({
                opacity: 0,
            })),
            state('active',   style({
                opacity: 1,
            })),
            transition('inactive => active', animate(200)),
            transition('active => inactive', animate(200))
        ])
    ]
})
export class LoaderComponent {
    public menuState = 'collapsed';
    public show: boolean;
    constructor(private loaderService: LoaderService) {}

    public animationChange(e: AnimationEvent) {
        if (e.phaseName === 'start' && e.toState === 'active') {
            this.show = true;
        } else if (e.phaseName === 'done' && e.toState === 'inactive') {
            this.show = false;
        }

        if (e.phaseName === 'done') {
            this.loaderService.reset();
        }
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./src/app/components/loader/loader.component.ts